import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormGenerator, ModalWrapper } from '@microservices/wiskey-react-components'
import { Box, Typography } from '@mui/material'

import { ModalFormContainer } from '@components/ModalFormContainer'

import { useMapSettingsDialog } from './hooks'

export const MapSettingsDialog = () => {
  const { t } = useTranslation()

  const {
    state: { methods, isDirty, isOpen },
    handlers: { handleSave, handleClose },
    inputs: { centerInputs, zoomInput, maxBoundsInputs },
  } = useMapSettingsDialog()

  if (!isOpen) return null

  return (
    <FormProvider {...methods}>
      <ModalWrapper
        disabledSave={!isDirty}
        isShow={isOpen}
        title={t('mapCreateOrEdit.mapSettingsDialogTitle')}
        width={600}
        containerStyle={{
          px: 0.5,
          py: 0.5,
        }}
        onClose={handleClose}
        onSave={handleSave}
      >
        <ModalFormContainer maxHeight={500}>
          <Box>
            <FormGenerator inputs={zoomInput} mainGridSpacing={0} />
          </Box>

          <Box mt={1}>
            <Typography mb={1} variant='h6'>
              {t('mapCreateOrEdit.mapSettingsCenter')}
            </Typography>
            <FormGenerator inputs={centerInputs} mainGridSpacing={0} />
          </Box>

          <Box mt={1}>
            <Typography mb={1} variant='h6'>
              {t('mapCreateOrEdit.mapSettingsMaxBounds')}
            </Typography>
            <FormGenerator inputs={maxBoundsInputs} mainGridSpacing={0} />
          </Box>
        </ModalFormContainer>
      </ModalWrapper>
    </FormProvider>
  )
}
